import { Ease } from 'pixi-ease'

export const ease = new Ease({ noTicker: true })